// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
	//TODO: write your page related code here...

$w.onReady(function () {
 
  let myLang = wixWindow.multilingual.currentLanguage; 
  if (myLang === 'he') {
    $w('#menueng').hide();
    $w('#menuheb').show();
    $w('#footermenueng').hide();
    $w('#footermenuheb').show();
      $w('#faq1eng').hide();
      $w('#faq2eng').hide();
    $w('#faq1heb').show();
    $w('#faq2heb').show();

  } else {
    $w('#footermenuheb').hide();
    $w('#footermenueng').show();
    $w('#menuheb').hide();
    $w('#menueng').show();
       $w('#faq1eng').show();
      $w('#faq2eng').show();
    $w('#faq1heb').hide();
    $w('#faq2heb').hide();
  }

});

// Import statements for the Wix Location and Window APIs.